import Route from '@ember/routing/route';

export default class HotelStrategyLeadtimeRoute extends Route {
  queryParams = {
    sortBy: {
      refreshModel: false,
    },
    sortDirection: {
      refreshModel: false,
    },
    tab: {
      refreshModel: false,
    },
  };
}
